/**
 * Update local data and propagate change to parent component by adding new value to total
 * @param {any} newValue - The new value to update local data with
 * @param {string} childColumn
 * @param {function} setData
 * @param {any} oldValue
 * @param {number} rowIndex
 * @param {function} setParentData
 * @param {string} parentColumn
 * @param {number} parentRow
 * @param {function} parse parse function
 * @param {function} setParentDataOriginal
 * @param {number} id_cuenta pare function
 */
const updateLocalDataAndParent = (
  newValue,
  childColumn,
  setData,
  oldValue,
  rowIndex,
  setParentData,
  parentColumn,
  parentRow,
  parse,
  setParentDataOriginal,
  id_cuenta,
  infoLabel = null
) => {
  setData(prevData => {
    return prevData.map((item, ind) => {
      if (ind === rowIndex) {
        return {
          ...item,
          [childColumn]: newValue,
          updated: [childColumn, ...(infoLabel ? [infoLabel.column] : [])],
          ...(infoLabel && { [infoLabel.column]: infoLabel.value }),
        };
      }
      return item;
    });
  });

  setParentData(prevData => {
    return prevData.map((item, ind) => {
      if (ind === parentRow) {
        return {
          ...item,
          [parentColumn]: parse(item[parentColumn]) + parse(newValue) - parse(oldValue),
          updated: [parentColumn],
          ...(infoLabel && {
            [infoLabel.parentColumn]: parse(item[infoLabel.parentColumn]) + parse(infoLabel.value) - parse(infoLabel.oldValue),
          }),
        };
      }
      return item;
    });
  });
  setParentDataOriginal &&
    setParentDataOriginal(prevData => {
      return prevData.map(item => {
        if (item.id_cuenta === id_cuenta) {
          return {
            ...item,
            [parentColumn]: parse(item[parentColumn]) + parse(newValue) - parse(oldValue),
            updated: [parentColumn],
            ...(infoLabel && {
              [infoLabel.parentColumn]: parse(item[infoLabel.parentColumn]) + parse(infoLabel.value) - parse(infoLabel.oldValue),
            }),
          };
        }
        return item;
      });
    });
};

export default updateLocalDataAndParent;
